var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroPromptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.238281 3.19099C0.238281 1.92862 1.26163 0.905273 2.524 0.905273H10.0003C11.2627 0.905273 12.2861 1.92862 12.2861 3.19099V3.66695C12.2861 4.08774 11.9449 4.42886 11.5241 4.42886C11.1034 4.42886 10.7622 4.08774 10.7622 3.66695V3.19099C10.7622 2.7702 10.4211 2.42908 10.0003 2.42908H2.524C2.10321 2.42908 1.76209 2.7702 1.76209 3.19099V9.47565C1.76209 9.89644 2.10321 10.2376 2.524 10.2376H10.0003C10.4211 10.2376 10.7622 9.89644 10.7622 9.47565V8.99969C10.7622 8.5789 11.1034 8.23778 11.5241 8.23778C11.9449 8.23778 12.2861 8.5789 12.2861 8.99969V9.47565C12.2861 10.738 11.2627 11.7614 10.0003 11.7614H2.524C1.26163 11.7614 0.238281 10.738 0.238281 9.47565V3.19099Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.059 3.10391C15.3701 2.82056 15.852 2.84305 16.1353 3.15413L18.5639 5.8205C18.8288 6.11127 18.8288 6.55583 18.5639 6.8466L16.1353 9.51297C15.852 9.82406 15.3701 9.84654 15.059 9.5632C14.7479 9.27985 14.7254 8.79796 15.0088 8.48687L16.2761 7.09546H5.85761C5.43682 7.09546 5.0957 6.75434 5.0957 6.33355C5.0957 5.91276 5.43682 5.57165 5.85761 5.57165H16.2761L15.0088 4.18023C14.7254 3.86914 14.7479 3.38726 15.059 3.10391Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroPromptIcon);
export default __webpack_public_path__ + "static/media/intro-prompt-icon.624b75dbdf4688f935948873014b38f5.svg";
export { ForwardRef as ReactComponent };